import { DATE_FORMAT } from '@ui-framework/index';
import dayjs from 'dayjs';
import { Box } from '@mui/material';
import ReadMoreText from '@ui-framework/components/UI/ReadMoreText';
import MultiValueDisplay from '@ui-framework/helpers/MultiValueDisplay';
import DispatchEventStatus from '../../../../../DispatchEventStatus';

function id(original) {
  return original?.id || '';
}

function dispatchId(original) {
  return original?.dispatchId || '';
}

function serviceProviderId(original) {
  return original?.serviceProviderId || '';
}

function serviceProviderName(original) {
  return original?.serviceProviderName || '';
}

function status(original) {
  return <DispatchEventStatus showAsText value={original?.status} />;
}

function serviceDate(original) {
  return original?.serviceDate
    ? dayjs(original?.serviceDate).format(DATE_FORMAT.MEDIUM_DATE)
    : '';
}

function acceptanceDate(original) {
  return original?.acceptanceDate
    ? dayjs(original?.acceptanceDate).format(DATE_FORMAT.LONG_DATE)
    : '';
}

function rejectionDate(original) {
  const data = [];
  if (original.status === 'REJECTED') {
    if (original?.rejectionDate) {
      data.push(
        <MultiValueDisplay title="Reject Date:">
          {dayjs(original?.rejectionDate).format(DATE_FORMAT.LONG_DATE)}
        </MultiValueDisplay>,
      );
    }
    if (original?.reason) {
      data.push(
        <MultiValueDisplay title="Reject Reason:" sx={{ mb: 1 }}>
          <ReadMoreText>{original?.reason}</ReadMoreText>
        </MultiValueDisplay>,
      );
    }
  }
  return data.map(d => <Box>{d}</Box>);
}

function lastModifiedDateTime(original) {
  return original?.lastModifiedDateTime
    ? dayjs(original?.lastModifiedDateTime).format(DATE_FORMAT.LONG_DATE)
    : '';
}

function createdDateTime(original) {
  return original?.createdDateTime
    ? dayjs(original?.createdDateTime).format(DATE_FORMAT.LONG_DATE)
    : '';
}

function conditions(original) {
  const data = [];
  if (original.status === 'ACCEPTED_WITH_CONDITIONS') {
    if (original?.serviceDate) {
      data.push(
        <MultiValueDisplay title="Service Date:">
          {dayjs(original?.serviceDate).format(DATE_FORMAT.MEDIUM_DATE)}
        </MultiValueDisplay>,
      );
    }
    if (original?.additionalMoney > 0) {
      data.push(
        <MultiValueDisplay
          type="currency"
          title="Additional Money:"
          sx={{ mb: 1 }}>
          {original?.additionalMoney}
        </MultiValueDisplay>,
      );
    }
    if (original?.reason) {
      data.push(
        <MultiValueDisplay title="Other reason:" sx={{ mb: 1 }}>
          <ReadMoreText>{original?.reason}</ReadMoreText>
        </MultiValueDisplay>,
      );
    }
    return data?.map(d => <Box>{d}</Box>);
  }
  return '';
}

export {
  id,
  dispatchId,
  serviceProviderId,
  serviceProviderName,
  status,
  serviceDate,
  acceptanceDate,
  rejectionDate,
  lastModifiedDateTime,
  createdDateTime,
  conditions,
};
